import { Box, Typography, Button, styled } from '@mui/material';

export const DashboardContainer = styled(Box)(({ theme }) => ({
  backgroundColor: '#f8f9fa', // Light grey background like in the design
  minHeight: '100vh',
}));

export const HeaderContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: theme.spacing(3),
}));

export const HeaderTitle = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
  fontSize: '1.5rem',
  color: '#1a1a1a',
}));

export const ActionButton = styled(Button)(({ theme }) => ({
  textTransform: 'none',
  fontWeight: 500,
  borderRadius: '8px',
  padding: '8px 16px',
  marginLeft: theme.spacing(2),
}));
